import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import { findConversation } from './findConversation';
import { tryConsumeFindConversationResponse } from 'owa-session-store/lib/services/sessionDataResponseStash';
import getFindConversationTraversal from './utils/getFindConversationTraversal';
/**
 * The FindConversationWithStartIndex is used today to load rows when we want to load them from the beginning (or 0th index)
 * This is currently used in load initial rows and in reload scenarios
 * @param folderId - The folderId for which we are fetching the data
 * @param startIndex - The index from where we want to fetch the rows
 * @param rowsToLoad - the number of rows to load
 * @param viewFilter - view filter (e.g - Unread\Flag)
 * @param sortResults - sort by properties
 * @param focusedViewFilter - whether focused view is on
 * @param findConversationShapeName - the shape for the request
 * @param shouldTryToUseSessionDataResponse - indicates if the call should try to use session data find conversation response
 * @param options - optional parameters to be passed to request (method and/or headers)
 * @param categoryName - the specific filter to use based on viewFilter
 */
export default function findConversationWithStartIndex(baseFolderId, startIndex, rowsToLoad, viewFilter, sortResults, focusedViewFilter, findConversationShapeName, shouldTryToUseSessionDataResponse, options, categoryName) {
    if (shouldTryToUseSessionDataResponse) {
        var sessionDataFindConversationResponse = tryConsumeFindConversationResponse(baseFolderId.Id, startIndex);
        if (sessionDataFindConversationResponse) {
            // Return the session data response if available instead of going to the server
            return Promise.resolve({
                findConversationResponseMessage: sessionDataFindConversationResponse.Body,
                responseInit: {
                    status: 200,
                    statusText: 'OK',
                    headers: new Headers(),
                },
            });
        }
    }
    var paging = indexedPageView({
        BasePoint: 'Beginning',
        Offset: startIndex,
        MaxEntriesReturned: rowsToLoad,
    });
    return findConversation(baseFolderId, paging, viewFilter, sortResults, focusedViewFilter, findConversationShapeName, options, categoryName, getFindConversationTraversal(viewFilter)).then(function (response) {
        return response.json().then(function (json) {
            return {
                findConversationResponseMessage: json.Body,
                responseInit: {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                },
            };
        });
    });
}
//# sourceMappingURL=findConversationWithStartIndex.js.map